/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Phone
 */
export interface Phone {
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Phone
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Phone
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    vehicleDeviceId?: string | null;
    /**
     * The unique id that's given to any android device. This id is read by the mobile app and transmitted to the back end.
     * @type {string}
     * @memberof Phone
     */
    androidId: string;
    /**
     * Set by the app to the last time of a successful self-update.
     * @type {Date}
     * @memberof Phone
     */
    appLastUpdatedAt: Date;
    /**
     * This current semantic version of the installed mobile app.
     * @type {string}
     * @memberof Phone
     */
    currentAppVersion: string;
}

/**
 * Check if a given object implements the Phone interface.
 */
export function instanceOfPhone(value: object): value is Phone {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('androidId' in value) || value['androidId'] === undefined) return false;
    if (!('appLastUpdatedAt' in value) || value['appLastUpdatedAt'] === undefined) return false;
    if (!('currentAppVersion' in value) || value['currentAppVersion'] === undefined) return false;
    return true;
}

export function PhoneFromJSON(json: any): Phone {
    return PhoneFromJSONTyped(json, false);
}

export function PhoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): Phone {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'vehicleDeviceId': json['vehicleDeviceId'] == null ? undefined : json['vehicleDeviceId'],
        'androidId': json['androidId'],
        'appLastUpdatedAt': (new Date(json['appLastUpdatedAt'])),
        'currentAppVersion': json['currentAppVersion'],
    };
}

export function PhoneToJSON(json: any): Phone {
    return PhoneToJSONTyped(json, false);
}

export function PhoneToJSONTyped(value?: Phone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'vehicleDeviceId': value['vehicleDeviceId'],
        'androidId': value['androidId'],
        'appLastUpdatedAt': value['appLastUpdatedAt'].toISOString(),
        'currentAppVersion': value['currentAppVersion'],
    };
}

